import { useEffect, useState } from 'react';

import RegulamentoLayout from 'components/regulamento-layout';
import { useAuth } from 'context/AuthContext';
import { ThemePlayer } from 'pages/Copa/components/ThemePlayer';
import { CopaThemePlayerProvider } from 'pages/Copa/CopaThemePlayerContext';
import { getManifest, IManifest } from 'services/manifest.service';

import './styles.scss';

export function Manifesto() {
  const [manifest, setManifest] = useState<IManifest>();
  const [load, setLoad] = useState<boolean>(true);
  const { user } = useAuth();

  useEffect(() => {
    async function loadData() {
      const data = await getManifest(user?.extra.rede);
      if (data) {
        setManifest(data);
      }

      setLoad(false);
    }

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RegulamentoLayout title="Manifesto">
      <div className="rounded-2xl bg-brand-white px-9 pb-10 pt-8 shadow-[0_1px_2px_rgba(21,21,24,.08),0_1px_3px_rgba(25,25,28,.12)]">
        {/* Tema do Joga Junto (AJH-30): provider local para a música parar ao sair da página, sem telemetria
            para não contar no relatório da Copa, e fora do HTML do CMS para o CSS dele não vazar no player. */}
        {/* A partir de 1280px o player fica na linha do título do CMS, à direita (`.manifesto-com-tema`); abaixo
            disso, no fluxo, centralizado acima do texto. */}
        <div className="manifesto-com-tema">
          <CopaThemePlayerProvider>
            <div className="manifesto-tema">
              <ThemePlayer themeName="Joga Junto BB" telemetry={false} aparencia="claro" />
            </div>
          </CopaThemePlayerProvider>

          {load && <div className="text-content-soft">Carregando...</div>}

          {!load && !!manifest?.text && <div className="manifesto" dangerouslySetInnerHTML={{ __html: manifest.text }}></div>}
        </div>
      </div>
    </RegulamentoLayout>
  );
}
